import { AccomodationReservation } from './../itineray.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-itinerary-reservations-accomodation-form-title',
  templateUrl: './itinerary-reservations-accomodation-form-title.component.html',
  styleUrls: ['./itinerary-reservations-accomodation-form-title.component.css']
})
export class ItineraryReservationsAccomodationFormTitleComponent implements OnInit {

  @Input()
  accomodation: AccomodationReservation;

  constructor() { }

  ngOnInit() {
  }

}
